module.exports = __webpack_public_path__ + "media/press/banner-prop-bef9158f.png";